import { useContext } from 'react'

import { AudioContext } from '@/contexts/AudioContext'

const useAudio = () => {
  return useContext(AudioContext)
}

export default useAudio
